import {
    DataSecurityWidget,
    BeatPhishingWidget,
    PhishingRiseWidget,
    Security2FA1Widget,
    Security2FA2Widget,
    Security2FA3Widget,
    TrustedDevices1Widget,
    TrustedDevices2Widget,
    TrustedDevices3Widget,
} from './components/DataSecurityWidget';

const DATASECURITY_WEIGHT = 20;

export const useDashboardDataSecurityWidgets = () => {
    const dataSecurityWidgets = [
        {
            component: <DataSecurityWidget />,
            weight: DATASECURITY_WEIGHT,
        },
        {
            component: <BeatPhishingWidget />,
            weight: DATASECURITY_WEIGHT,
        },
        {
            component: <PhishingRiseWidget />,
            weight: DATASECURITY_WEIGHT,
        },
        ...trustedDevicesWidgets,
        ...security2FAWidgets,
    ];

    return dataSecurityWidgets;
};

const trustedDevicesWidgets = [
    {
        component: <TrustedDevices1Widget />,
        weight: DATASECURITY_WEIGHT,
    },
    {
        component: <TrustedDevices2Widget />,
        weight: DATASECURITY_WEIGHT,
    },
    {
        component: <TrustedDevices3Widget />,
        weight: DATASECURITY_WEIGHT,
    },
];

const security2FAWidgets = [
    {
        component: <Security2FA1Widget />,
        weight: DATASECURITY_WEIGHT,
    },
    {
        component: <Security2FA2Widget />,
        weight: DATASECURITY_WEIGHT,
    },
    {
        component: <Security2FA3Widget />,
        weight: DATASECURITY_WEIGHT,
    },
];
